export default __webpack_public_path__ + "static/media/mixedSqrt.07598346.svg";